/* tslint:disable */
/* eslint-disable */
/**
 * notifications
 * notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NotificationPreferenceListEntry } from './NotificationPreferenceListEntry';
import {
    NotificationPreferenceListEntryFromJSON,
    NotificationPreferenceListEntryFromJSONTyped,
    NotificationPreferenceListEntryToJSON,
    NotificationPreferenceListEntryToJSONTyped,
} from './NotificationPreferenceListEntry';

/**
 * 
 * @export
 * @interface NotificationPreferenceCategoryListEntry
 */
export interface NotificationPreferenceCategoryListEntry {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    user_id?: string;
    /**
     * 
     */
    preferences?: Array<NotificationPreferenceListEntry>;
}

/**
 * Check if a given object implements the NotificationPreferenceCategoryListEntry interface.
 */
export function instanceOfNotificationPreferenceCategoryListEntry(value: object): value is NotificationPreferenceCategoryListEntry {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function NotificationPreferenceCategoryListEntryFromJSON(json: any): NotificationPreferenceCategoryListEntry {
    return NotificationPreferenceCategoryListEntryFromJSONTyped(json, false);
}

export function NotificationPreferenceCategoryListEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationPreferenceCategoryListEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'user_id': json['user_id'] == null ? undefined : json['user_id'],
        'preferences': json['preferences'] == null ? undefined : ((json['preferences'] as Array<any>).map(NotificationPreferenceListEntryFromJSON)),
    };
}

export function NotificationPreferenceCategoryListEntryToJSON(json: any): NotificationPreferenceCategoryListEntry {
    return NotificationPreferenceCategoryListEntryToJSONTyped(json, false);
}

export function NotificationPreferenceCategoryListEntryToJSONTyped(value?: NotificationPreferenceCategoryListEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'user_id': value['user_id'],
        'preferences': value['preferences'] == null ? undefined : ((value['preferences'] as Array<any>).map(NotificationPreferenceListEntryToJSON)),
    };
}

